var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.3 11.875c0-.412.336-.747.75-.747h8a.749.749 0 1 1 0 1.495h-8a.75.75 0 0 1-.75-.748m.75 2.243a.749.749 0 1 0 0 1.496h8a.749.749 0 1 0 0-1.496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.03 5.246h1.72c.967 0 1.75.782 1.75 1.745v11.265c0 .963-.784 1.744-1.75 1.744H6.25c-.966 0-1.75-.781-1.75-1.744V6.99c0-.964.784-1.745 1.75-1.745h1.82A1.5 1.5 0 0 1 9.55 4h5a1.5 1.5 0 0 1 1.48 1.246M8.07 6.741H6.25a.25.25 0 0 0-.25.25v11.265a.25.25 0 0 0 .25.249h11.5a.25.25 0 0 0 .25-.25V6.992a.25.25 0 0 0-.25-.25h-1.72a1.5 1.5 0 0 1-1.48 1.247h-5A1.5 1.5 0 0 1 8.07 6.74Zm.98-1.246a.5.5 0 0 1 .5-.498h5a.5.5 0 0 1 .5.498v.997a.5.5 0 0 1-.5.499h-5a.5.5 0 0 1-.5-.499z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.624a8c9f.svg";